import { useIsFetching } from "@tanstack/react-query";
import LoadingScreen from "components/base/LoadingScreen/LoadingScreen";
import Stepper from "components/base/Stepper/Stepper";
import Header from "components/ui/Header/Header";
import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import FirstScreen from "routes/Home/screens/FirstScreen/FirstScreen";
import SecondScreen from "routes/Home/screens/SecondScreen/SecondScreen";
import styles from "./styles.module.scss";
import useGetData from "hooks/api/useGetData";
import useGetStatus from "hooks/api/useGetStatus";
import { COMPANY_FLOW_TYPE } from "constants/flowTypes";
import { t } from "i18next";

const HomeRoute = () => {
  // Index 0 represents first page
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const { id = "123", type: flowType } = useParams();
  const navigate = useNavigate();
  const [statusPollingInterval, setStatusPollingInterval] = useState(2000);

  const { isLoading, isError } = useGetData();
  const {
    data: dataStatus,
    isDone: isDoneStatus,
    isPending: isPendingStatus,
    isError: isErrorStatus,
    isOpen: isOpenStatus
  } = useGetStatus({ refetchInterval: statusPollingInterval });

  // Do polling only if payment is initiated
  useEffect(() => {
    if (dataStatus) {
      if (dataStatus && dataStatus.isPaymentInitiated) {
        setStatusPollingInterval(2000);
      } else {
        setStatusPollingInterval(0);
      }
    }
  }, [dataStatus]);

  // Navigate user based on status
  useEffect(() => {
    if (isDoneStatus || isErrorStatus) {
      navigate(`/${flowType}/${id}/details`);
    }
  }, [id, navigate, isDoneStatus, flowType, isErrorStatus]);

  const isPayFetching = useIsFetching(["pay"]);

  const isPayLoading =
    isPayFetching > 0 || isPendingStatus || (dataStatus?.isPaymentInitiated && isOpenStatus);

  return (
    <>
      {isError ? (
        <Navigate to={`/404`} />
      ) : (
        <>
          <Header />
          {/* Loading screen for first app load */}

          {isLoading && <LoadingScreen type="light" isLoading />}

          {/* Loading screen for payment */}
          {isPayLoading && <LoadingScreen type="dark" title={t("loader.label")} isLoading />}

          <div className={styles.screenContainer}>
            <Stepper activeStepIndex={activeStepIndex}>
              <FirstScreen
                data-testid="first-screen-route"
                data-nav={t(
                  flowType === COMPANY_FLOW_TYPE
                    ? "homePage.companyStepperTitleFirstScreen"
                    : "homePage.stepperTitleFirstScreen"
                )}
                key={0}
                setActiveStepIndex={setActiveStepIndex}
              />
              <SecondScreen
                data-testid="second-screen-route"
                data-nav={t(
                  flowType === COMPANY_FLOW_TYPE
                    ? "homePage.companyStepperTitleSecondScreen"
                    : "homePage.stepperTitleSecondScreen"
                )}
                key={1}
                setActiveStepIndex={setActiveStepIndex}
              />
            </Stepper>
          </div>
        </>
      )}
    </>
  );
};

export default HomeRoute;
